<script setup>
import PretendardText from "@/components/atoms/text/PretendardText.vue";
import HeaderModal from "./HeaderModal.vue";
import HeaderSubMenu from "./HeaderSubMenu.vue";
import MHeaderMenu from "./MHeaderMenu.vue";
import { displayHooks } from "@/hooks/useDisplay";
import { menu } from "@/constants/menu";
import { route } from "@/router/route";
import { router } from "@/router";
import { onBeforeMount, ref } from "vue";
import MenuApi from "@/api/menu";
import { useToast } from "vue-toastification";
const toast = useToast();

let headerModalOpen = ref(false);
let headerMobileOpen = ref(false);
let activeMenu = ref(-1);

const list = ref([]);
const subMenu = ref([]);

const modalOpen = () => {
  headerModalOpen.value = true;
};

const modalClose = () => {
  headerModalOpen.value = false;
};

const mobileOpen = () => {
  headerMobileOpen.value = true;
};

const mobileClose = () => {
  headerMobileOpen.value = false;
};

const changeActiveMenu = (index) => {
  subMenu.value = list.value[index].subMenus;
  if (subMenu.value.length > 0) {
    activeMenu.value = index;
  }
};

const changeDeActiveMenu = () => {
  activeMenu.value = -1;
};

const defaultRouter = () => {
  router.push({ path: `${route.default}` });
};

const menuRouter = (item, index) => {
  if (item.subMenus[0]?.boardId) {
    router.push({ path: route.board + `/${item.subMenus[0]?.boardId}` });
    return;
  }
  router.push({ path: route[`${menu[index].link}1`] });
};

onBeforeMount(() => {
  getMenu();
});

const getMenu = async () => {
  try {
    const data = {
      exposureFlag: true,
    };

    const response = await MenuApi.get(data);

    if (response.data.data) {
      list.value = response.data.data.content.reverse();
    }
  } catch (e) {
    toast("서버에 문제가 있습니다. 잠시후 다시 시도하세요.", {
      toastClassName: "toast-wrapper",
      position: "top-center",
      timeout: 2000,
      hideProgressBar: true,
      closeButton: false,
      icon: false,
    });
  }
};
</script>

<template>
  <div v-if="displayHooks.isDesktop" class="header-wrapper">
    <div class="header-left">
      <img
        alt=""
        src="../../../assets/img/logo_color.png"
        style="cursor: pointer"
        @click="defaultRouter"
      />
      <div class="submenu-container" @mouseleave="changeDeActiveMenu">
        <div class="menu-wrapper">
          <PretendardText
            v-for="(item, index) in list"
            :key="index"
            class="menu-text"
            @mouseover="changeActiveMenu(index)"
            @click="menuRouter(item, index)"
            >{{ item.title }}</PretendardText
          >
        </div>
        <HeaderSubMenu
          :activeMenu="activeMenu"
          :subMenu="subMenu"
          @changeDeActiveMenu="changeDeActiveMenu"
        />
      </div>
    </div>
    <div class="header-right">
      <div class="sns-wrapper">
        <a>
          <img
            alt=""
            src="../../../assets/ico/blog.png"
            style="cursor: pointer"
          />
        </a>
        <a
          href="https://www.instagram.com/huss_dku?igsh=cjN5cDR1eHQ3aWE3&utm_source=qr"
          target="blank"
        >
          <img
            alt=""
            src="../../../assets/ico/insta.png"
            style="cursor: pointer"
          />
        </a>
        <a href="https://www.youtube.com/@huss_dku" target="blank">
          <img
            alt=""
            src="../../../assets/ico/youtube.png"
            style="cursor: pointer"
          />
        </a>
      </div>
      <img
        @click="modalOpen()"
        alt=""
        src="../../../assets/ico/header_btn.png"
        style="cursor: pointer"
      />
    </div>
  </div>
  <div class="mobile-header-wrapper" v-if="!displayHooks.isDesktop">
    <img
      src="../../../assets/ico/btn/main_hamberger.png"
      alt=""
      @click="mobileOpen()"
    />
  </div>
  <MHeaderMenu
    v-if="headerMobileOpen"
    :subMenu="subMenu"
    @modalClose="mobileClose"
  />
  <HeaderModal v-if="headerModalOpen" @modalClose="modalClose" />
</template>

<style lang="scss" scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  padding: 0 50px;
  background: $white;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.25);
  position: sticky;
  top: 0;
  z-index: 3;

  & > .header-left {
    display: flex;
    align-items: center;
    gap: 153px;
    height: 100%;

    & .submenu-container {
      height: 100%;
    }

    & .menu-wrapper {
      display: flex;
      align-items: center;
      height: 100%;

      & > .menu-text {
        color: $g02;
        font-size: 18px;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.6px;
        cursor: pointer;
        padding: 0 20px;
        height: 100%;
        display: flex;
        align-items: center;

        &:first-child {
          padding-left: 0;
        }

        &:hover {
          color: #044a85;
        }
      }
    }
  }

  & > .header-right {
    display: flex;
    align-items: center;
    gap: 30px;

    & > .sns-wrapper {
      display: flex;
      align-items: center;
      gap: 16px;
      cursor: pointer;
    }
  }
}

.mobile-header-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #ffffff;
}
</style>
